import { WidgetInstance } from "mobx-store/stores/customScreens/types";
import { ValidationOptionsKeys } from "screens/addEditCustomScreen/types";
import { ValidationSchema } from "../validation.helper";

export interface Props {
  focusedWidgetData: WidgetInstance;
  focusedWidget: null | string | number;
  handleChangeData: (paramName: string, value: string) => void;
  removeFocusedWidget: () => void;
}

export const occupancyWidgetValidation: ValidationSchema =  {
  title: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
  description: [{ validation: [ValidationOptionsKeys.REQUIRED],}],
}